import React from 'react'

const PipelineIcon = (props) => (
  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 16 16"  fill="#de595b" {...props}>
  <path d="M5.1,7.8c-.2,0-.3.1-.3.3v2.9c0,.1.1.3.3.3h.6c.2,0,.3-.1.3-.3v-2.9c0-.1-.1-.3-.3-.3h-.6Z"/>
  <path d="M10.9,11.2c.2,0,.3-.1.3-.3v-2.9c0-.1-.1-.3-.3-.3h-.6c-.2,0-.3.1-.3.3v2.9c0,.1.1.3.3.3h.6Z"/>
  <path d="M6.1,8.1h0v2.9s0,0,0,0h3.7s0,0,0,0v-2.9s0,0,0,0h-.4c-.3,0-.5-.2-.5-.5v-1.4s0,0,0,0h-1.9s0,0,0,0v1.4c0,.3-.2.5-.5.5h-.4s0,0,0,0Z"/>
  <path d="M7.1,6h1.9c.2,0,.3-.1.3-.3v-.6c0-.1-.1-.3-.3-.3h-1.9c-.2,0-.3.1-.3.3v.6c0,.1.1.3.3.3Z"/>
  <path d="M14.1,7.8h-.6c-.2,0-.3.1-.3.3h0s-1.9,0-1.9,0c0,0,0,0,0,0v2.9s0,0,0,0h1.9c0,.2.1.3.3.3h.6c.2,0,.3-.1.3-.3h1.4v-2.9h-1.4c0-.2-.1-.3-.3-.3Z"/>
  <path d="M1.9,11.2h.6c.2,0,.3-.1.3-.3h0s1.9,0,1.9,0c0,0,0,0,0,0v-2.9s0,0,0,0h-1.9c0-.2-.1-.3-.3-.3h-.6c-.2,0-.3.1-.3.3H.2v2.9h1.4c0,.2.1.3.3.3Z"/>
</svg>
)

export default PipelineIcon
